import { nsCustomization } from '@/app/i18n/namespaces';
import CUSTOMIZATION_STATUS from '../enums/CustomizationStatus';

export default {
    UUID: {
        key: 'uuid'
    },
    MERCHANT_UUID: {
        key: 'contractAccessUuid'
    },
    IDENTIFIANT: {
        key: 'packageCode',
        entity: 'keys.packageCode',
        namespace: nsCustomization,
        filter: 'input',
        enableSorting: true,
        placeholder: 'filter.placeholder.package_code'
    },
    COLOR: {
        key: 'color',
        entity: 'keys.color',
        namespace: nsCustomization,
        filter: 'input',
        type: 'color',
        enableSorting: true,
        placeholder: 'filter.placeholder.color'
    },
    LABEL: {
        key: 'packageLabel',
        entity: 'keys.packageLabel',
        namespace: nsCustomization,
        filter: 'input',
        enableSorting: true,
        placeholder: 'filter.placeholder.package_label'
    },
    LOGO: {
        key: 'logo',
        type: 'file',
        entity: 'keys.logo',
        namespace: nsCustomization
    },
    LOCALE: {
        key: 'locale',
        entity: 'keys.locale',
        namespace: nsCustomization,
        filter: 'input',
        enableSorting: true,
        placeholder: 'filter.placeholder.locale'
    },
    STATUS: {
        key: 'status',
        type: 'select',
        namespace: nsCustomization,
        prefix: 'status.',
        entity: 'keys.status',
        filter: 'select',
        enum: CUSTOMIZATION_STATUS,
        enableSorting: true
    },
    POS_TERMINALS_NUMBERS: {
        key: 'posTerminalsNumbers',
        entity: 'keys.posTerminalsNumbers',
        namespace: nsCustomization,
        enableSorting: true
    },
    CREATED_AT: {
        key: 'createdAt',
        entity: 'keys.createdAt',
        namespace: nsCustomization,
        type: 'date',
        filter: 'date',
        enableSorting: true
    },
    UPDATED_AT: {
        key: 'updatedAt',
        entity: 'keys.updatedAt',
        namespace: nsCustomization,
        type: 'date',
        filter: 'date',
        enableSorting: true
    },
    SCENARIOS: {
        key: 'scenarios',
        PACKAGE_NAME: {
            key: 'packageName',
            parentKeys: ['scenarios']
        },
        TRANSACTION_TYPE: {
            key: 'transactionType',
            parentKeys: ['scenarios']
        },
        SCENARIO: {
            key: 'scenario',
            parentKeys: ['scenarios'],
            STEP_NAME: {
                key: 'stepName',
                parentKeys: ['scenarios', 'scenario']
            },
            PARAMS: {
                key: 'params',
                parentKeys: ['scenarios', 'scenario'],
                INPUT_TYPE: {
                    key: 'inputType',
                    parentKeys: ['scenarios', 'scenario', 'params']
                }
            }
        }
    },
    MPF_OPTIONS: {
        key: 'mpfOptions',
        NAME: {
            parentKeys: ['mpfOptions'],
            key: 'name'
        },
        VALUE: {
            parentKeys: ['mpfOptions'],
            key: 'value'
        },
        DONATIONS_MODE: {
            parentKeys: ['mpfOptions'],
            key: 'donationMode',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'donationMode']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'donationMode']
            }
        },
        AUTOMATE_MODE: {
            parentKeys: ['mpfOptions'],
            key: 'automateMode',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'automateMode']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'automateMode']
            }
        },
        AMOUNT_SCREEN_DISPLAY: {
            parentKeys: ['mpfOptions'],
            key: 'amountScreenDisplay',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'amountScreenDisplay']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'amountScreenDisplay']
            }
        },
        APP_TO_APP_MODE: {
            parentKeys: ['mpfOptions'],
            key: 'appToAppMode',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'appToAppMode']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'appToAppMode']
            }
        },
        CONCERT_PROTOCOL_V3_2: {
            parentKeys: ['mpfOptions'],
            key: 'concertProtocolV320',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'concertProtocolV320']
            },
            VALUE: {
                key: 'value',
                PORT: {
                    key: 'port',
                    parentKeys: ['mpfOptions', 'concertProtocolV320', 'value']
                }
            }
        },
        CONCERT_PROTOCOL_V2: {
            parentKeys: ['mpfOptions'],
            key: 'concertProtocolV2',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'concertProtocolV2']
            },
            VALUE: {
                key: 'value',
                SPEED_RATE: {
                    key: 'speedRate',
                    parentKeys: ['mpfOptions', 'concertProtocolV2', 'value']
                }
            }
        },
        CONCERT_PROTOCOL_V2_USB: {
            parentKeys: ['mpfOptions'],
            key: 'concertProtocolV2Usb',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'concertProtocolV2Usb']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'concertProtocolV2Usb']
            }
        },
        DEMATERIALIZED_RECEIPT_QR_CODE: {
            parentKeys: ['mpfOptions'],
            key: 'dematerializedReceiptQrCode',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'dematerializedReceiptQrCode']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'dematerializedReceiptQrCode']
            }
        },
        KIOSK_MODE: {
            parentKeys: ['mpfOptions'],
            key: 'kioskMode',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'kioskMode']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'kioskMode']
            }
        },
        BURGER_MENU_LOCK: {
            parentKeys: ['mpfOptions'],
            key: 'burgerMenuLock',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'burgerMenuLock']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'burgerMenuLock']
            }
        },
        TIPS: {
            parentKeys: ['mpfOptions'],
            key: 'tip',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'tip']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'tip']
            }
        },
        WAITER_NUMBER: {
            parentKeys: ['mpfOptions'],
            key: 'waiterNumber',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'waiterNumber']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'waiterNumber']
            }
        },
        TABLE_NUMBER: {
            parentKeys: ['mpfOptions'],
            key: 'tableNumber',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'tableNumber']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'tableNumber']
            }
        },
        NATIVE_MERCHANT_RECEIPT: {
            parentKeys: ['mpfOptions'],
            key: 'nativeMerchantReceipt',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'nativeMerchantReceipt']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'nativeMerchantReceipt']
            }
        },
        NATIVE_CUSTOMER_RECEIPT: {
            parentKeys: ['mpfOptions'],
            key: 'nativeCustomerReceipt',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'nativeCustomerReceipt']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'nativeCustomerReceipt']
            }
        },
        FORCING_GATEWAY: {
            parentKeys: ['mpfOptions'],
            key: 'forcingGateway',
            NAME: {
                key: 'name',
                parentKeys: ['mpfOptions', 'forcingGateway']
            },
            VALUE: {
                key: 'value',
                parentKeys: ['mpfOptions', 'forcingGateway']
            }
        }
    },
    DETAILS: {
        key: 'details'
    },
    BENEFICIARIES: {
        key: 'beneficiaries',
        NAME: {
            key: 'name',
            parentKeys: ['beneficiaries']
        },
        COLOR: {
            key: 'color',
            parentKeys: ['beneficiaries']
        },
        CONTRACTS: {
            key: 'contracts',
            parentKeys: ['beneficiaries']
        },
        CONTRACT_ACCESS: {
            key: 'contractAccess',
            parentKeys: ['beneficiaries']
        },
        CREATED_AT: {
            key: 'createdAt',
            parentKeys: ['beneficiaries']
        },
        UPDATED_AT: {
            key: 'updatedAt',
            parentKeys: ['beneficiaries']
        },
        UUID: {
            key: 'uuid',
            parentKeys: ['beneficiaries']
        }
    }
};